<div class="container" [formGroup]="dialogData.form">
  @if (dialogData.withSearch) {
    <div class="search">
      <fu-simple-input
        formControlName="search"
        [useOutlineLabel]="false"
        [label]="'accountWithAmount.search.label' | translate"
        [placeholder]="dialogData.searchPlaceholder | translate"
        (click)="$event.stopPropagation()"
      />

      <fu-icon class="search-icon" iconName="search" size="16" />
    </div>
  }

  @if (dialogData.listLabel) {
    <p class="list-label">{{ dialogData.listLabel | translate }}</p>
  }

  @if (accounts()?.length) {
    <div class="accounts">
      @for (account of accounts(); track account.id) {
        <div
          class="account-item"
          (click)="selectAccount(account)"
          [class.disabled]="isItemDisabled(account)"
        >
          @switch (account.viewType) {
            @case ("user") {
              <iw-user-item [user]="account" useThemeImage />
            }
            @case ("currency") {
              <iw-currency-item [account]="account" useThemeImage />
            }
            @default {
              <iw-account-item
                [account]="account"
                [defaultCurrency]="dialogData.defaultCurrency"
              />
            }
          }
        </div>
      }
    </div>
  } @else {
    <div class="empty-list">
      <fu-icon class="icon" iconName="help-circle" size="20" />

      <p class="message">
        <span class="message-title">{{
          "accountWithAmount.emptyList.title" | translate
        }}</span>
        <span class="message-subtitle">
          {{ "accountWithAmount.emptyList.subtitle" | translate }}</span
        >
      </p>
    </div>
  }
</div>
